"use client"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { FormRegisterProps, RenderConfig } from "./RenderConfig"

export const ApplyForm: ComponentConfig<FormRegisterProps> = {
  label: "Apply Form",
  //@ts-ignore
  fields: {
    NameForm: {
      type: "text",
      label: "Name Form",
    },
    Subtitle: {
      type: "text",
      label: "Subtitle",
    },
    Email: {
      type: "text",
      label: "Email",
    },
    ...commonStylesProps,
  },
  defaultProps: {
    className: "",
    NameForm: "Join Us",
    Subtitle: "Submit Your Application",
    Email: "quocminhly23@gmail.com",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
